import {
    GET_ALL_KOTAK_RECORDS_REQUEST,
    GET_ALL_KOTAK_RECORDS_SUCCESS,
    GET_ALL_KOTAK_RECORDS_FAIL,
    GET_ALL_KOTAK_RECORDS_RESET,

    CREATE_KOTAK_RECORD_REQUEST,
    CREATE_KOTAK_RECORD_SUCCESS,
    CREATE_KOTAK_RECORD_FAIL,
    CREATE_KOTAK_RECORD_RESET,

    UPDATE_KOTAK_RECORD_REQUEST,
    UPDATE_KOTAK_RECORD_SUCCESS,
    UPDATE_KOTAK_RECORD_FAIL,
    UPDATE_KOTAK_RECORD_RESET,

    DELETE_KOTAK_RECORD_REQUEST,
    DELETE_KOTAK_RECORD_SUCCESS,
    DELETE_KOTAK_RECORD_FAIL,
    DELETE_KOTAK_RECORD_RESET,

    BULK_DELETE_KOTAK_RECORDS_REQUEST,
    BULK_DELETE_KOTAK_RECORDS_SUCCESS,
    BULK_DELETE_KOTAK_RECORDS_FAIL,
    BULK_DELETE_KOTAK_RECORDS_RESET,

    IMPORT_KOTAK_RECORDS_REQUEST,
    IMPORT_KOTAK_RECORDS_SUCCESS,
    IMPORT_KOTAK_RECORDS_FAIL,
    IMPORT_KOTAK_RECORDS_RESET,

    EXPORT_KOTAK_RECORDS_REQUEST,
    EXPORT_KOTAK_RECORDS_SUCCESS,
    EXPORT_KOTAK_RECORDS_FAIL,
    EXPORT_KOTAK_RECORDS_RESET,
} from '../constants/KotakConstants';

// Get all Kotak records reducer
export const kotakRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_ALL_KOTAK_RECORDS_REQUEST:
            return { loadingKotakRecords: true };
        case GET_ALL_KOTAK_RECORDS_SUCCESS:
            return {
                loadingKotakRecords: false,
                kotakRecordsData: action.payload,
            };
        case GET_ALL_KOTAK_RECORDS_FAIL:
            return {
                loadingKotakRecords: false,
                errorKotakRecords: action.payload,
            };
        case GET_ALL_KOTAK_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};

// Create Kotak record reducer
export const createKotakRecordReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_KOTAK_RECORD_REQUEST:
            return { loading: true };
        case CREATE_KOTAK_RECORD_SUCCESS:
            return { loading: false, success: true, record: action.payload };
        case CREATE_KOTAK_RECORD_FAIL:
            return { loading: false, error: action.payload };
        case CREATE_KOTAK_RECORD_RESET:
            return {};
        default:
            return state;
    }
};

// Update Kotak record reducer
export const updateKotakRecordReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_KOTAK_RECORD_REQUEST:
            return { loadingUpdateKotakRecord: true };
        case UPDATE_KOTAK_RECORD_SUCCESS:
            return {
                loadingUpdateKotakRecord: false,
                updateKotakRecordData: action.payload,
            };
        case UPDATE_KOTAK_RECORD_FAIL:
            return {
                loadingUpdateKotakRecord: false,
                errorUpdateKotakRecord: action.payload,
            };
        case UPDATE_KOTAK_RECORD_RESET:
            return {};
        default:
            return state;
    }
};

// Delete Kotak record reducer
export const deleteKotakRecordReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_KOTAK_RECORD_REQUEST:
            return { loading: true };
        case DELETE_KOTAK_RECORD_SUCCESS:
            return { loading: false, success: true };
        case DELETE_KOTAK_RECORD_FAIL:
            return { loading: false, error: action.payload };
        case DELETE_KOTAK_RECORD_RESET:
            return {};
        default:
            return state;
    }
};

// Bulk delete Kotak records reducer
export const bulkDeleteKotakRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case BULK_DELETE_KOTAK_RECORDS_REQUEST:
            return { loadingBulkDeleteKotakRecords: true };
        case BULK_DELETE_KOTAK_RECORDS_SUCCESS:
            return {
                loadingBulkDeleteKotakRecords: false,
                bulkDeleteKotakRecordsData: action.payload,
            };
        case BULK_DELETE_KOTAK_RECORDS_FAIL:
            return {
                loadingBulkDeleteKotakRecords: false,
                errorBulkDeleteKotakRecords: action.payload,
            };
        case BULK_DELETE_KOTAK_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};


// Import Kotak records reducer
export const importKotakRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case IMPORT_KOTAK_RECORDS_REQUEST:
            return { loading: true };
        case IMPORT_KOTAK_RECORDS_SUCCESS:
            return { loading: false, success: true, importResult: action.payload };
        case IMPORT_KOTAK_RECORDS_FAIL:
            return { loading: false, error: action.payload };
        case IMPORT_KOTAK_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};

// Export Kotak records reducer
export const exportKotakRecordsReducer = (state = {}, action) => {
    switch (action.type) {
        case EXPORT_KOTAK_RECORDS_REQUEST:
            return { loading: true };
        case EXPORT_KOTAK_RECORDS_SUCCESS:
            return { loading: false, success: true, message: action.payload };
        case EXPORT_KOTAK_RECORDS_FAIL:
            return { loading: false, error: action.payload };
        case EXPORT_KOTAK_RECORDS_RESET:
            return {};
        default:
            return state;
    }
};
